
import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { toDatabaseValue } from "@/utils/supabase/type-guards";

export const usePromptDelete = (promptId: string, user: any, onDelete?: (id: string) => void) => {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!user) return;
    
    setIsDeleting(true);
    try {
      const { error } = await supabase
        .from('prompts')
        .delete()
        .eq('id', toDatabaseValue(promptId))
        .eq('user_id', toDatabaseValue(user.id));
      
      if (error) throw error;
      
      toast.success("Prompt deleted");
      
      if (onDelete) {
        onDelete(promptId);
      }
      
      setIsDeleteDialogOpen(false);
    } catch (error: any) {
      console.error('Error deleting prompt:', error);
      toast.error(error.message || "Failed to delete prompt");
    } finally {
      setIsDeleting(false);
    }
  };

  return {
    isDeleteDialogOpen,
    isDeleting,
    setIsDeleteDialogOpen,
    handleDelete
  };
};
